import { useState } from 'react';
import { User } from '../_types/user.types';
import { ApiLocalStorage } from '../../../utils/ApiLocalStorage';
import { useUserDataService } from '../services/getUserData.service';
import { UpdateUserDataRequestTypes } from '../_types/updateUserDataRequest.types';
import { USER_DATA_KEY } from '../constantes/LocalStorageEnum';

export const useGetUserData = () => {
  const [userData, setUserData] = useState<User | null>(() =>
    ApiLocalStorage.get(USER_DATA_KEY)
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const userDataService = useUserDataService();
  
  const getUserData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await userDataService.getUserData();
      const userData: User = response.fields;
      
      ApiLocalStorage.set(USER_DATA_KEY, userData);
      setUserData(userData);
      
      return response;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to fetch user data');
      setError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };
  
  const updateUserData = async (data: UpdateUserDataRequestTypes) => {
    try {
      setLoading(true);
      setError(null);
      
      await userDataService.updateUserData(data);
      await getUserData();
      
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to update user data');
      setError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };
  
  const clearUserData = () => {
    ApiLocalStorage.remove(USER_DATA_KEY);
    setUserData(null);
  };
  
  return {
    userData,
    loading,
    error,
    getUserData,
    updateUserData,
    clearUserData
  };
};
